import { AlertTriangle } from "lucide-react";

/**
 * Phase 64 — Compact "UNFIT" badge shown next to a candidate name across the
 * ATS when the candidate has been globally marked as not suitable at all
 * (via POST /api/candidates/{cid}/unfit).
 *
 * Renders nothing if `unfit` is falsy — safe to sprinkle everywhere.
 */
export default function UnfitBadge({ unfit, reason, size = "sm" }) {
    if (!unfit) return null;
    const px = size === "md" ? "px-2 py-0.5 text-[10px]" : "px-1.5 py-0.5 text-[9px]";
    const icon = size === "md" ? "w-3 h-3" : "w-2.5 h-2.5";
    return (
        <span
            className={`inline-flex items-center gap-1 font-mono uppercase tracking-widest border border-rose-300 bg-rose-50 text-rose-700 ${px}`}
            title={reason ? `Marked unfit — ${reason}` : "Marked unfit"}
            data-testid="unfit-badge"
        >
            <AlertTriangle className={icon} /> Unfit
        </span>
    );
}
